import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'

/** 播放器图标的css基类 */
export abstract class _PlayEntryBase extends BaseCssVarValue {
  abstract cssType: 'default'
  /** 播放器圆形宽度 */
  ['--play-entry-width']?: string;
  /** 播放器圆形高度 */
  ['--play-entry-height']?: string;
  /** 播放器图标宽度 */
  ['--play-icon-width']?: string;
  /** 播放器图标高度 */
  ['--play-icon-height']?: string
}
